export const positionItems = [
  { value: 'student', label: 'Student' },
  { value: 'professional', label: 'Professional' },
  { value: 'educator', label: 'Educator' },
  { value: 'other', label: 'Other' },
];

export const validReferralCodes = ['TGL', '1559'];

export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xpwjewjd';
